var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIbm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 34,
    viewBox: "0 0 84 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 84,
    height: 34,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 16.332,
    height: 2.359,
    transform: "translate(0 31.633)",
    fill: "#1f70c1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 16.332,
    height: 2.367,
    transform: "translate(0 27.108)",
    fill: "#1f70c1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 7.006,
    height: 2.367,
    transform: "translate(4.659 22.591)",
    fill: "#1f70c1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 7.006,
    height: 2.367,
    transform: "translate(4.659 18.075)",
    fill: "#1f70c1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 7.006,
    height: 2.367,
    transform: "translate(4.659 13.558)",
    fill: "#1f70c1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 7.006,
    height: 2.367,
    transform: "translate(4.659 9.033)",
    fill: "#1f70c1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 16.332,
    height: 2.367,
    transform: "translate(0 4.517)",
    fill: "#1f70c1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 16.332,
    height: 2.367,
    transform: "translate(0 0)",
    fill: "#1f70c1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4454",
    "data-name": "Path 4454",
    d: "M18.662,29.475H43.78a8.455,8.455,0,0,0,.932-2.367H18.662Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4455",
    "data-name": "Path 4455",
    d: "M41.825,18.075H23.33v2.367H43.781a9.454,9.454,0,0,0-1.955-2.367",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4456",
    "data-name": "Path 4456",
    d: "M23.33,13.558v2.367h18.5a8.791,8.791,0,0,0,1.955-2.367Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4457",
    "data-name": "Path 4457",
    d: "M43.781,4.517H18.662V6.884h26.05a10.3,10.3,0,0,0-.932-2.367",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4458",
    "data-name": "Path 4458",
    d: "M36.059,0h-17.4V2.367h23.4a8.789,8.789,0,0,0-6-2.367",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 6.997,
    height: 2.367,
    transform: "translate(23.33 9.033)",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4459",
    "data-name": "Path 4459",
    d: "M37.332,11.4h7.322a8.927,8.927,0,0,0,.316-2.367H37.332Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 6.997,
    height: 2.367,
    transform: "translate(23.33 22.591)",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4460",
    "data-name": "Path 4460",
    d: "M37.332,22.591v2.367H44.97a8.928,8.928,0,0,0-.316-2.367Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4461",
    "data-name": "Path 4461",
    d: "M18.662,33.975l17.4.025a8.8,8.8,0,0,0,6.007-2.367h-23.4Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 11.665,
    height: 2.359,
    transform: "translate(46.668 31.633)",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 11.665,
    height: 2.367,
    transform: "translate(46.668 27.108)",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 7.006,
    height: 2.367,
    transform: "translate(51.327 22.591)",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 7.006,
    height: 2.367,
    transform: "translate(51.327 18.075)",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4462",
    "data-name": "Path 4462",
    d: "M61.577,4.517H46.668V6.884H62.384Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4463",
    "data-name": "Path 4463",
    d: "M60.03,0H46.668V2.367H60.837Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 11.673,
    height: 2.359,
    transform: "translate(72.327 31.633)",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 11.673,
    height: 2.367,
    transform: "translate(72.327 27.108)",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 7.006,
    height: 2.367,
    transform: "translate(72.327 22.591)",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 7.006,
    height: 2.367,
    transform: "translate(72.327 18.075)",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4464",
    "data-name": "Path 4464",
    d: "M72.327,15.925h7.006V13.558H65.987l-.657,1.914-.657-1.914H51.327v2.367h7.006V13.751l.741,2.174H71.586l.74-2.174Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4465",
    "data-name": "Path 4465",
    d: "M79.332,9.033h-11.8L66.727,11.4h12.6Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4466",
    "data-name": "Path 4466",
    d: "M70.638,0l-.807,2.367H84V0Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4467",
    "data-name": "Path 4467",
    d: "M65.33,33.975l.807-2.342H64.523Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4468",
    "data-name": "Path 4468",
    d: "M63.782,29.475h3.1l.832-2.367H62.958Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4469",
    "data-name": "Path 4469",
    d: "M62.21,24.959h6.24l.824-2.367H61.386Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4470",
    "data-name": "Path 4470",
    d: "M60.645,20.442h9.377l.8-2.367H59.838Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4471",
    "data-name": "Path 4471",
    d: "M51.327,11.4h12.6l-.807-2.367h-11.8Z",
    fill: "#1f70c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4472",
    "data-name": "Path 4472",
    d: "M68.283,6.884H84V4.517H69.082Z",
    fill: "#1f70c1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbm);
export default __webpack_public_path__ + "static/media/IBM.d80f40c22fb9d0d58b9529c3189f1812.svg";
export { ForwardRef as ReactComponent };